"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNetworkOptions = void 0;
const network_1 = require("../network");
const getNetworkOptions = (chainId) => {
    const networkOptions = Object.values(network_1.network)
        .find((network) => network.chainId === chainId);
    if (!networkOptions) {
        throw new Error(`Unknown chainId: ${chainId}`);
    }
    return networkOptions;
};
exports.getNetworkOptions = getNetworkOptions;
